import { Site } from '@/models/Site';

export interface SiteListState {
    siteList: Site[];
    page: number;
    pages: number;
    filter: string;
    isLoading: boolean;
    error: boolean;
    scroll: number;
    siteId: number;
}

export const state = (): SiteListState => ({
    siteList: [],
    pages: 0,
    page: 0,
    filter: '',
    isLoading: false,
    error: false,
    scroll: 0,
    siteId: 0,
});
